import React from 'react'

import '../styles/LoadingScreen.css'

const LoadingScreen = ({ progress }) =>
{
  return (
    <>
      <div className="flex w-screen h-screen items-center justify-center flex-col z-[9999] bg-black fixed inset-0">
        <div className="loader-container mb-8">
          <div className="cube">
            <div className="face top"></div>
            <div className="face front side"></div>
            <div className="face right side"></div>
            <div className="face back side"></div>
            <div className="face left side"></div>
            <div className="face bottom side"></div>
          </div>
        </div>

        <div className="w-64 h-1 bg-gray-800 rounded-full overflow-hidden mb-4">
          <div
            className="h-full bg-white transition-all duration-200 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>

        <span className='text-white text-center font-mono text-sm tracking-widest'>
          LOADING {Math.floor(progress)}%
        </span>
      </div>
    </>
  )
}

export default LoadingScreen
